module.exports = __webpack_public_path__ + "static/img/ksrk_logo4.7920f46.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/官网首页/firstlink/ksrk_logo4.png
// module id = vbLa
// module chunks = 1